import i18n from './i18n';
import {ISSUE_TYPES_PERMITTED_ACTIONS} from '../constants/issue-types';
import {sortAlphabeticallyByPath} from './sortingHelpers';
import {getGroupedOptionsFromTreeByPredicate} from './tree-helpers';

export const issueTypeInputValidators = (issueTypeNames, existsTranslationKey = 'exists') => [
  {
    message: i18n.t('issueTypes.modal.maxCharactersLimit'),
    validate: text => !text || text.length <= 50
  },
  {
    message: i18n.t(`issueTypes.modal.${existsTranslationKey}`),
    validate: text => !text || !issueTypeNames.includes(text.trim().toLowerCase())
  }
];

export const subIssueTypeInputValidators = issueTypeNames => {
  const baseIssueTypeValidators = issueTypeInputValidators(issueTypeNames, 'subTypeExists');
  baseIssueTypeValidators.push({
    message: i18n.t('issueTypes.modal.spaces'),
    validate: text => !text || (text.length > 0 && text.trim().length !== 0)
  });
  return baseIssueTypeValidators;
};

export const isStandardType = issueType =>
  issueType &&
  !issueType.isContainerType &&
  issueType.permittedActions &&
  !issueType.permittedActions.includes(ISSUE_TYPES_PERMITTED_ACTIONS.CAN_DELETE);

export const sortIssueTypeByOrderIndex = (a, b) => a.orderIndex - b.orderIndex;

export const isImmediateSubType = (issueSubType, parentIssueType) =>
  parentIssueType && parentIssueType.immediateSubTypeId === issueSubType.id;

export const formatSubtypeDisplayValue = (subtypeId, fieldIssueTypeEntitiesMap) => {
  if (subtypeId) {
    const selected = fieldIssueTypeEntitiesMap[subtypeId];
    if (selected) {
      const subTypeTitle = selected.title;
      const typeId = selected.parentId;
      const typeTitle = fieldIssueTypeEntitiesMap[typeId].title;

      if (subTypeTitle === typeTitle) {
        return subTypeTitle;
      }

      return `${typeTitle} > ${subTypeTitle}`;
    }
    return null;
  }

  return null;
};

export const getSubtypesTreeByPredicate = (predicate, entitiesMap, issueTypes) => {
  const groupedOptions = getGroupedOptionsFromTreeByPredicate(issueTypes, predicate, entitiesMap);
  return sortAlphabeticallyByPath(groupedOptions, '[0]');
};
